import { render, staticRenderFns } from "./data-list-based-on-org.html?vue&type=template&id=09d5824c&scoped=true&external"
import script from "./data-list-based-on-org.js?vue&type=script&lang=js&external"
export * from "./data-list-based-on-org.js?vue&type=script&lang=js&external"
import style0 from "./data-list-based-on-org.scss?vue&type=style&index=0&id=09d5824c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5824c",
  null
  
)

export default component.exports